import React from "react";
import PropTypes from "prop-types";
import Icon, { SIZES, STYLE_TYPES } from "../atoms/Icon";
import classNames from "classnames";

const SupportTeaser = ({
  className,
  linkLabel,
  linkTarget,
  onClick,
  teaserImageSrc,
}) => (
  <div
    className={classNames("sal-support-teaser", className)}
    onClick={onClick}
  >
    <a href={linkTarget} className="sal-support-teaser__card-link" />
    <div className="sal-support-teaser__flex-container">
      {teaserImageSrc ? (
        <div className="sal-support-teaser__image-container">
          <img
            src={teaserImageSrc}
            alt={linkLabel}
            className="sal-support-teaser__image"
          />
        </div>
      ) : null}
      <span href={linkTarget} className="sal-support-teaser__text-container">
        {linkLabel} <Icon type={STYLE_TYPES.PFEIL_NACH_RECHTS} size={SIZES.S} />
      </span>
    </div>
  </div>
);

SupportTeaser.propTypes = {
  className: PropTypes.string,
  linkLabel: PropTypes.string,
  linkTarget: PropTypes.string,
  onClick: PropTypes.func,
  teaserImageSrc: PropTypes.string,
};
export default SupportTeaser;
